import React from 'react';

export default function Loader() {
    return (
        <div className="fixed inset-0 z-50 grid place-items-center bg-gray-900/90">
            <div className="relative h-20 w-20">
                <div className="absolute inset-0 animate-[spin_1s_linear_infinite] rounded-full bg-gradient-to-tr from-blue-500 via-cyan-400 to-indigo-500 p-[2px]">
                    <div className="h-full w-full rounded-full bg-gray-900" />
                </div>
                <div className="absolute inset-2 animate-pulse rounded-full bg-gradient-to-br from-blue-600/30 to-indigo-600/30" />
            </div>
            <p className="mt-6 text-sm font-medium text-white/80">Loading portal…</p>
        </div>
    );
}
